'use strict';

function DashRoutes ($stateProvider) {

  $stateProvider

  // serves as a template for all dashboard authenticated sub-routes
  .state('dash', {
    abstract: true,
    controller: 'DashController',
    controllerAs: 'vm',
    templateUrl: 'dash/dash.tpl.html',
    resolve: {
      authenticate: [
        '$location', '$state', '$q', '$timeout', 'AuthService',
        function ($location, $state, $q, $timeout, AuthService) {
          var deferred = $q.defer();
          var authenticated = AuthService.isAuthenticated();
          var params = {
            location: ''
          };
          $timeout(function () {
            if (authenticated) {
              deferred.resolve();
            } else {
              $state.go('login', params);
              deferred.reject();
            }
          });
          return deferred.promise;
        }
      ],
      organization: [
        'sbFlux', 'authenticate', 'IngestorService',
        function (Flux, authenticate, IngestorService) {
          var OrganizationStore = Flux.Store.get('OrganizationStore');
          var PlanStore = Flux.Store.get('PlanStore');
          return OrganizationStore.loadOrganization()
          .then(function (organization) {
            return PlanStore.preloadOrgPlanData()
          })
          .then(() => {
            IngestorService.attachIngestor()
          })
        }
      ]
    }
  });
}

DashRoutes.$inject = ['$stateProvider'];
module.exports = DashRoutes;


// WEBPACK FOOTER //
// ./src/app/dash/DashRoutes.js